import React from 'react';
import { Box, TextField, IconButton, InputAdornment } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

const CustomInputField = ({ value, onChange, onAdd, error = '', placeholder = 'Enter value' }) => {
  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onAdd();
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.25rem', width: '100%' }}>
      <TextField
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        size="small"
        fullWidth
        placeholder={placeholder}
        error={Boolean(error)}
        helperText={error}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={onAdd}>
                <AddIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
        sx={{
          '& .MuiInputBase-root': {
            fontSize: '0.85rem',
            fontWeight: 'bold',
            color: 'black',
          },
          '& .MuiFormHelperText-root': {
            marginLeft: 0,
          },
        }}
      />
    </Box>
  );
};

export default CustomInputField;
